<template>
  <div class="body">
    <div id="uiContainer" class="uiContainer"></div>
    <div id="container" class="container"></div>

    <a class="introdution" @click="onStartClick" v-show="showIntrodution">
      <img :src="require('@/assets/mobControll.png')" style="width: 300px" />
    </a>
    <a-modal
      title="请输入密码"
      :visible="ShowPasswordInput"
      @ok="getViewAuth"
      @cancel="handleCancel"
    >
      <a-input v-model="password" />
    </a-modal>
    <!-- 模型展示界面 -->
    <div class="colorpicker_container" v-show="isshowcolorpicker">
      <sketch-picker
        class="colorpicker"
        v-model="color"
        @input="colorValueChange"
      ></sketch-picker>
      <button
        class="colorpicker"
        type="button"
        @click="changeColor"
        style="
          width: 222px;
          background-color: rgb(255, 255, 255);
          border: none;
          outline: none;
          border-radius: 5px;
          cursor: pointer;
        "
      >
        确&#32;定
      </button>
    </div>
    <!-- footer -->
    <div class="footer">
      <div class="footer-item" @click="modelInfo">
        <img class="foot-item-image" :src="require('@/assets/组 13@2x.png')" />
        <p class="foot-item-text">模型信息</p>
      </div>
      <div class="footer-item" @click="changcolorclick">
        <img class="foot-item-image" :src="require('@/assets/组 3@2x.png')" />
        <p class="foot-item-text">背景颜色</p>
      </div>
      <div class="footer-item" @click="viewtools_click">
        <img
          class="foot-item-image"
          :src="require('@/assets/组 1 拷贝@2x.png')"
        />
        <p class="foot-item-text">工具箱</p>
      </div>
      <a-dropdown
        class="footer-item"
        :placement="view_placement"
        :trigger="['click']"
        size:small
        style="size: small"
      >
        <div>
          <img
            class="foot-item-image"
            :src="require('@/assets/组 2 拷贝@2x.png')"
          />
          <p class="foot-item-text">多媒体</p>
        </div>
        <a-menu slot="overlay">
          <!-- <a-menu-item class="footer-item-drop-item" v-if="model.mp3fileName" @click="playMp3">
            <img
              class="footer-item-drop-img"
              :src="require('@/assets/矢量智能对象@2x(1).png')"
            />
            <p class="footer-item-drop-text">语音解说</p>
          </a-menu-item>
          <a-menu-divider v-if="model.mp3fileName"></a-menu-divider> -->
          <a-menu-item class="footer-item-drop-item" v-if="model.mlink" @click="openMlink">
            <img
              class="footer-item-drop-img"
              :src="require('@/assets/矢量智能对象1@2x.png')"
            />
            <p class="footer-item-drop-text">网页</p>
          </a-menu-item>
          <a-menu-divider v-if="model.mlink"></a-menu-divider>
          <a-menu-item class="footer-item-drop-item" v-if="model.vrAddr" @click="openVR">
            <img
              class="footer-item-drop-img"
              :src="require('@/assets/矢量智能对象@2x(2).png')"
            />
            <p class="footer-item-drop-text">全景</p>
          </a-menu-item>
          <a-menu-divider v-if="model.vrAddr"></a-menu-divider>
          <a-menu-item class="footer-item-drop-item" v-if="model.videoAddr" @click="openVideoAddr">
            <img
              class="footer-item-drop-img"
              :src="require('@/assets/矢量智能对象@2x(3).png')"
            />
            <p class="footer-item-drop-text">视频</p>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <!-- 顶部工具 -->
    <div id="headbar" class="headbar">
      <img
        id="logo"
        class="logo"
        :src="'./model/show/' + model.logoPath"
        v-show="model.logoPath ? true : false"
      />
      <div class="headbar-left">
        <img class="headbar-left-eye" src="@/assets/矢量智能对象@2x.png" />
        <a-divider class="headbar-left-divider" type="vertical" />
        <p class="headbar-left-times">{{ model.viewTimes }}</p>
      </div>
    </div>
    <!-- 工具栏 -->
    <div id="toolbar" class="toolbar" v-show="showviewtools">
      <div class="toolbar-item">
        <div class="toolbar-row-item">
          <p class="toolbar-row-item-text">剖切</p>
        </div>
        <div class="toolbar-row-item">
          <img class="toolbar-row-item-image" src="@/assets/椭圆 1@2x.png" />
          <p class="toolbar-row-item-text">X轴</p>
          <a-switch class="toolbar-row-item-switcher" @change="trim_right"></a-switch>
        </div>
        <div class="toolbar-row-item">
          <img
            class="toolbar-row-item-image"
            src="@/assets/椭圆 1 拷贝 2@2x.png"
          />
          <p class="toolbar-row-item-text">Y轴</p>
          <a-switch class="toolbar-row-item-switcher" @change="trim_top"></a-switch>
        </div>
        <div class="toolbar-row-item">
          <img
            class="toolbar-row-item-image"
            src="@/assets/椭圆 1 拷贝 3@2x.png"
          />
          <p class="toolbar-row-item-text">Z轴</p>
          <a-switch class="toolbar-row-item-switcher" @change="trim_front"></a-switch>
        </div>
        <div class="toolbar-row-item">
          <a-button class="toolbar-row-item-button" @click="dont_showAxis"> </a-button>
        </div>
      </div>
      <a-divider class="toolbar-divider" type="vertical" />
      <div class="toolbar-item">
        <div class="toolbar-row-item">
          <p class="toolbar-row-item-text">操作</p>
        </div>
        <div class="toolbar-row-item">
          <p class="toolbar-row-item-text">结构</p>
          <a-switch class="toolbar-row-item-switcher" @change="setOpacty" v-model="opactied"></a-switch>
        </div>
        <div class="toolbar-row-item"></div>
        <div class="toolbar-row-item">
          <p class="toolbar-row-item-text">炸开</p>
          <a-switch class="toolbar-row-item-switcher" @change="explode" v-model="exploded"></a-switch>
        </div>
        <div class="toolbar-row-item">
          <a-button class="toolbar-row-item-button1" @click="resetmodel"> </a-button>
        </div>
      </div>
    </div>
    <!--左边工具栏-->
    <div class="leftbar" id="leftbar" style="visibility:hidden" >
     <div class="leftbar-item" id="up" >
        <img class="leftbar-item-image" :src="require('@/assets/up.png')" />
      </div>
      <a class="floor_shower" />
      <div class="leftbar-item" id="down">
        <img class="leftbar-item-image" :src="require('@/assets/down.png')" />
      </div>
    </div>
    <a-progress
      type="dashboard"
      v-show="modelView.showProgress"
      :percent="modelView.progress"
      style="
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -50px;
        margin-left: -50px;
      "
    />
      <!--展示模型信息-->
    <div class="modelInfo" v-show="modelInfoVisible">
      <img class="modelInfo-background" src="@/assets/info_bg.png" />
      <div class="modelInfo-header">
        <img class="modelInfo-header-param" src="@/assets/矩形 39 拷贝@2x.png" alt=""/>
        <p class="modelInfo-header-text">模型信息</p>
        <img class="modelInfo-header-param" src="@/assets/矩形 39@2x.png" alt=""/>
      </div>
       <img class="modelInfo-header-close" src="@/assets/close.png" @click="closeModelInfo"/>
      <p class="modelInfo-info" v-html="model.remark ? model.remark:'暂无模型信息'"></p>
    </div>
  </div>
</template>

<script>
import * as THREE from "three";
import { Sketch } from "vue-color";
import { Server } from "../../../js/Server/Server";
import { SceneManager } from "../../../js/Scene/SceneManager";

export default {
  metaInfo: {
    meta: [{ charset: "utf-8" }],
  },
  components: {
    "sketch-picker": Sketch,
  },
  name: "Model",
  data() {
    return {
      title: "模型浏览",
      intitClipe: false,
      server: new Server(),
      sceneManager: null,
      view_placement: "topCenter",
      firstTimeOnlocal: "true",
      showIntrodution: true,
      dontshowAxis:false,
      color: "",
      modelInfoVisible: false,
      isshowcolorpicker: false,
      showviewtools:false,
      mp3Player:null,
      mp3Playing:false,
      modelView: {
        title: "",
        showProgress: true,
        progress: 0,
        logoShow: true,
      },
      scene: null,
      camera_p: null,
      camera_o: null,
      renderer: null,
      controls: null,
      clock: new THREE.Clock(),
      ShowPasswordInput: false,
      password: "",
      enableShadow: false,
      meta: [],
      loadedObj: null,
      model: {
        backgroundColor: "rgb(222,222,222)",
        coverPath: "",
        enableView: "",
        needPassword: false,
        mp3fileName: "",
        password: "",
        modelPath: "",
        id: "",
        logoPath: "",
        MapsPath: "",
        Name: "",
        path: "",
        remark: "暂无模型信息",
        uploadTime: "",
        vrAddr: "",
        viewTimes: 10,
        videoAddr:"",
        mlink:"",
      },
      initInfo: {
         camera_x_position: 30,
        camera_y_position: 30,
        camera_z_position: 30,
        enableMainLight: true,
        mainLightIntensity: 0.1,
        enableShadow:false,
        enableLightProbe:true,
        enableEnvironmentLight: true,
        environmentLightIntensity: 0.6,
      },
      enableClip_y: false,
      enableClip_x: false,
      enableClip_z: false,
      showOpactyButton: false,
      explodeModel: null,
      exploded:false,
      opactied:false,

      //数据可视化
      showDataBox: false,
      temp: "温度：16.6℃",
      hum: "湿度：60.5%",
      
    };
  },
  mounted() {
    this.mp3Player=document.getElementsByName('mp3Play');
    this.modelView.showProgress = true;
    this.model.id=this.$route.query.id;
    var id_obj = { id: this.model.id };
    this.initScene();
    this.server.getModel(id_obj, this.getMoldeCallBack);
    let firstTime = localStorage.getItem("firstTimeOnlocal");
    if (firstTime == "false") {
      this.firstTimeOnlocal = false;
      this.showIntrodution = false;
    } else {
      let secondsToGo = 7;
      const interval = setInterval(() => {
        secondsToGo -= 1;
      }, interval);
      setTimeout(() => {
        clearInterval(interval);
        this.showIntrodution = false;
      }, secondsToGo * 1000);
    }
    localStorage.setItem("firstTimeOnlocal", false);
    window.onresize = () => {
      this.onWindowResize();
    };
  },
  destroyed() {
    if (this.sceneManager) {
      this.sceneManager.closeWebSocket();
    }
  },
  methods: {
    getMoldeCallBack(model) {
      this.model = model.model;
      if (this.model.initInfo) {
        this.initInfo = JSON.parse(this.model.initInfo);
      }
      this.sceneManager.configEvironment(this.initInfo,this.enableShadow);
      this.sceneManager.setBackGroundColor(this.model.backgroundColor);
      this.modelView.title = this.model.name;
      this.modelView.logoShow = true;
      if (this.model.needPassword == "true") {
        this.ShowPasswordInput = true;
      }
      document.title = this.model.name;
      this.meta = [
        { property: "og:type", content: "website" },
        { property: "og:title", content: "页面标题" },
        { property: "og:description", content: "页面描述" },
        {
          property: "og:image",
          // content: "./model/show/" + model.logoPath,
        },
        { property: "og:url", content: "http://www.example.com/" },
      ];
      if (!this.model.modelFileType) {
        this.model.modelFileType = this.model.modelPath.substring(
          this.model.modelPath.lastIndexOf(".") + 1
        );
      }
      let modPath = "./model/show/" + this.model.modelPath;
      let mapPath;
      if (this.model.mapsPath == "" || this.model.mapsPath == null) {
        mapPath = "";
      } else {
        mapPath =
          this.model.path + "/" + this.model.mapsPath + "/";
      }
      this.sceneManager.loadModel(
        modPath,
        mapPath,
        this.model.modelFileType,
        this.progress,
        this.modelLoadFinish
      );
    },
    playMp3(){
      if(!this.mp3Playing){
        this.mp3Player.play();
        this.mp3Playing=true;
      }else{
        this.mp3Player.stop();
        this.mp3Playing=false;
      }
    },
    getViewAuth() {
      if (this.password == this.model.password) {
        this.ShowPasswordInput = false;
      } else {
        this.$message.error("密码错误");
      }
    },
    handleCancel() {
      this.ShowPasswordInput = false;
    },
    viewtools_click(){
      this.showviewtools=!this.showviewtools;
    },
    //#region 视图操作
    trim_top(value) {
      this.enableClip_y=value;
      if(value){
this.sceneManager.clipe(1);
      }else{
this.sceneManager.closeClipe(1);
      }
    },
    trim_bottom() {},
    trim_front(value) {
      this.enableClip_x = value;
      if (value) {
        this.sceneManager.clipe(0);
      } else {
        this.sceneManager.closeClipe(0);
      }
    },
    trim_back() {},
    trim_left() {},
    trim_right(value) {
      this.enableClip_z = value;
      if (value) {
        this.sceneManager.clipe(2);
      } else {
        this.sceneManager.closeClipe(2);
      }
    },
    dont_showAxis() {
      this.dontshowAxis=!this.dontshowAxis;
      this.sceneManager.dont_showAxis(this.dontshowAxis)
    },
    //#endregion

    explode() {
       if (!this.exploded) {
        this.sceneManager.explodeModel.explode();
        this.exploded = true;
      } else {
        this.sceneManager.explodeModel.resetExplode();
        this.exploded = false;
      }
    },
    setOpacty(value) {
      this.isOpacty = !this.isOpacty;
      this.sceneManager.setOpacty(value);
    },

    //选择颜色
    changcolorclick() {
      this.isshowcolorpicker = !this.isshowcolorpicker;
    },
    showInfo() {
      this.sceneManager.showInfo();
    },
    //模型信息
    modelInfo() {
      this.modelInfoVisible = true;
    },
    closeModelInfo() {
      this.modelInfoVisible = false;
    },
    colorValueChange(val) {
      var bgColor = colorRgb(val.hex);
      this.model.backgroundColor = bgColor;
      this.sceneManager.setBackGroundColor(this.model.backgroundColor);
    },
    changeColor() {
      this.isshowcolorpicker = false;
      this.server.updateColor(this.model);
    },
    openVR() {
      window.open(this.model.vrAddr, "_blank");
    },
    openMlink() {
      window.open(this.model.mlink, "_blank");
    },
    openVideoAddr() {
      window.open(this.model.videoAddr, "_blank");
    },
    onStartClick() {
      this.showIntrodution = false;
    },
    viewReturnOrigin() {
      this.sceneManager.viewReturnOrigin();
    },
    initScene() {
      this.sceneManager = new SceneManager(this.model.id);
      this.sceneManager.setFloorUI(document.getElementById("leftbar"));
      let doElement = this.sceneManager.initScene(
        this.model.backgroundColor,
        document,
        this.onSenssionClick,
        this.onSenssionMessage
      );

      let container = document.getElementById("container");
      container.childNodes.forEach((childNode) => {
        container.removeChild(childNode);
      });
      container.appendChild(doElement[0]);

      let uiContainer = document.getElementById("uiContainer");
      uiContainer.childNodes.forEach((childNode) => {
        uiContainer.removeChild(childNode);
      });
      uiContainer.appendChild(doElement[1]);

      this.animate();
    },

    onWindowResize() {
      this.sceneManager.onWindowResize();
    },
    animate() {
      requestAnimationFrame(this.animate);
      const delta = this.clock.getDelta();
 if (this.mixer)
        this.mixer.update(delta);
      this.sceneManager.animate();
      this.sceneManager.animate(delta);
    },
    tweenanimate() {
      var id = requestAnimationFrame(this.tweenanimate);

      var result = this.sceneManager.tweenanimate();

      if (!result) cancelAnimationFrame(id);
    },
    progress(xhr) {
      if (xhr.loaded == xhr.total) {
        this.modelView.showProgress = false;
      } else {
        this.modelView.progress = Math.ceil(
          ((xhr.loaded / xhr.total) * 100).toFixed(2)
        );
      }
    },
    modelLoadFinish(data) {
      this.showOpactyButton = data.hasOpactyMesh;
    },
      stringToHex: function (str) {
      var val = "";
      for (var i = 0; i < str.length; i++) {
        //先转成unicode编码,再转成对应的16进制
        val += "" + str.charCodeAt(i).toString(16);
      }
      return val;
    },
    //数据据可视化
    onSenssionClick: function () {
      this.showDataBox = !this.showDataBox;
    },
    onSenssionMessage: function (msg) {
      this.hum = "湿度：" + msg.hum / 100 + "%";
      this.temp = "温度：" + msg.temp / 100 + "℃";
    },
  },
};

//颜色转换

function colorRgb(rgb) {
  // 16进制颜色值的正则
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 把颜色值变成小写
  var color = rgb.toLowerCase();
  if (reg.test(color)) {
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      var colorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
    }
    // 处理六位的颜色值，转为RGB
    var colorChange = [];
    for (var j = 1; j < 7; j += 2) {
      colorChange.push(parseInt("0x" + color.slice(j, j + 2)));
    }
    return "rgb(" + colorChange.join(",") + ")";
  } else {
    return color;
  }
}
</script>

<style scoped>
.body {
  width: 100%;
  height: 100%;
}
.header {
  border: false;
  text-align: center;
  height: 6.5%;
  align-content: center;
}
.headbar {
  position: absolute;
  background-color: #ffffff00;
  top: 1%;
  height: 6.5%;
  width: 100%;
  display: flex;
}
.headbar-left {
  width: auto;
  height: 100%;
  margin: auto 5% auto auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.headbar-left-eye {
  height: 50%;
  width: auto;
  margin: auto;
  padding: 0 10% 0 10%;
}
.headbar-left-divider {
  margin: auto;
  padding: 0 1% 0 1%;
}
.headbar-left-times {
  color: #ff6600;
  margin: auto 1%;
  font-size: 1.2em;
  padding: 0 10% 0 10%;
}
.logo {
  height: 60%;
  width: auto;
  margin: auto 5%;
}
.footer {
  position: absolute;
  bottom: 0px;
  height: 10%;
  width: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
}
.footer-item {
  width: 25%;
  height: 60%;
  display: flex;
  flex-direction: column;
}
.foot-item-image {
  margin: auto;
  height: 32px;
  width: 32px;
}
.foot-item-text {
  margin: auto;
  font-size: 8px;
}
.footer-item-drop-img {
  width: 60%;
  height: auto;
  margin: auto;
}
.footer-item-drop-text {
  color: #ff6600;
  font-size: 12px;
  width: 100%;
  text-align: center;
}
.footer-item-drop-item {
  width: 60px;
  height: 60px;
  margin: auto;
  display: flex;
  flex-direction: column;
}
.colorpicker_container {
  width: 100%;
  height: 100%;
  position: absolute;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  display: -webkit-flex;
}
.shareModel {
  display: flex;
}
.introdution {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.836);
  width: 100%;
  height: 100%;
}
.hotPoint {
  width: 100px;
  height: 100px;
  background: tomato;
}
.container {
  width: 100%;
  height: 100%;
  position: absolute;
  /* pointer-events:none; */
}
.uiContainer {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}
/* 数据据可视化 */
.baseBoxLeft {
  width: 360px;
  height: 480px;
  background: url(../../../assets/senssion/left.png) no-repeat;
  background-size: contain;
  position: absolute;
  top: 16%;
  left: 2%;
}
.boxTitle {
  font-size: 20px;
  color: #0efcff;
  width: 80px;
  margin-left: 30px;
  margin-top: 10px;
  text-align: left;
  position: absolute;
}
.cameraList {
  width: 320px;
  height: 160px;
  margin: 48px auto auto auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.camera {
  width: 160px;
  height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.camera_content {
  width: 150px;
  height: 120px;
}
.camera_text {
  color: #0efcff;
  text-align: start;
}
.senssion {
  width: 320px;
  height: 240px;
  color: #0efcff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 6px auto auto auto;
  justify-content: space-between;
}
.senssion_item {
  width: 74px;
  height: 74px;
  margin: 2px;
}
.senssion_item_img {
  width: 60px;
  height: 60px;
}
.toolbar {
  width: 100%;
  height: 24%;
  background-color: #ffffff;
  position: absolute;
  display: flex;
  flex-direction: row;
}
.toolbar-divider {
  height: 80%;
  margin: auto;
}
.toolbar-item {
  height: 100%;
  width: 50%;
}
.toolbar-row-item {
  width: 100%;
  height: 20%;
  display: flex;
  flex-direction: row;
}
.toolbar-row-item-text {
  font-size: 18px;
  margin: auto;
}
.toolbar-row-item-image {
  width: 14px;
  height: 14px;
  margin: auto;
}
.toolbar-row-item-switcher {
  margin: auto;
  box-sizing: border-box;
}
.toolbar-row-item-button {
  height: 80%;
  width: 50%;

  background-size: cover;
  background-repeat: round;
  background-image: url("../../../assets/组 6@2x.png");
  margin: auto;
}
.toolbar-row-item-button1 {
  height: 80%;
  width: 50%;

  background-size: cover;
  background-repeat: round;
  background-image: url("../../../assets/组 6 拷贝@2x.png");
  margin: auto;
}
.modelInfo{
  width: 90%;
  height: 60%;
  position: absolute;
  margin: 30% 5% ;
  display: flex;
}
.modelInfo-header{
  width: 100%;
  height: 45px;
  position: absolute;
  top: 0;
  display: flex;
  justify-content:start ;
  padding: 0 22% 0 22%;
}
.modelInfo-header-param{
  height: 5%;
  width: auto;
  margin: auto;
}
.modelInfo-header-text{
  font-size: 16px;
  margin: auto;
  color: #ff6600;
}
.modelInfo-background{
  width: 100%;
  height: auto;
}
.modelInfo-info{
width: 95%;
height: 80%;
position: absolute;
margin: 20% 2.5%;
text-align: left;
font-size: 1em;
}
.modelInfo-header-close{
  height: 6%;
  position: absolute;
  right: 5%;
  top: 3%;
}
.leftbar{
  user-select: none;
width: 80px;
height: 200px;
display: flex;
flex-direction: column;
position:absolute;
top: 50%;
justify-content: space-around;
margin: -100px 0 0 30px;
}
.leftbar-item{
  user-select: none;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.leftbar-item-image{
  user-select: none;
  width: 40px;
  height: 40px;
}
.floor_shower{
  text-align: center;
  color:#3fa9f5;
  user-select: none;
}
</style>